import { render } from "./ResultElement.vue?vue&type=template&id=5289d127&scoped=true"
import script from "./ResultElement.vue?vue&type=script&lang=js"
export * from "./ResultElement.vue?vue&type=script&lang=js"

import "./ResultElement.vue?vue&type=style&index=0&id=5289d127&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5289d127"

export default script